module.exports = __webpack_public_path__ + "static/media/bring-forward.6de49854.svg";